var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('contract-association-manager',{attrs:{"assoc-fetch":_vm.tableFetch,"assoc-fetch-active":_vm.tableFetchActive,"assoc-archive":_vm.tableArchive,"assoc-restore":_vm.tableRestore,"table-columns":_vm.tableColumns}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34d277dd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Organization/organizationData/organizationSettingsAssets.vue
// module id = null
// module chunks = 